import React from 'react';
import { Route } from 'react-router-dom';


const Factory = ( model, metadata ) => {
  return (
    <>
      {( () => {

        const item = model[ 'settings' ];

        const Pages = require( '../../../pages/auth' ).default;

        const Page = Pages.Data[ item.Page ];

        return <Route path={item.section} element={<Page />} />;
      } )()}

      {( () => {

        const item = model[ 'users' ];

        const Pages = require( '../../../pages/auth' ).default;

        const Page = Pages.Data[ item.Page ];

        return <Route path={item.section} element={<Page />} />;
      } )()}
    </>
  );
};

export default Factory;